import Icon from "@/components/icon";
import TeaserHeading from "@/components/teaser-heading";
import { Content } from "@/services/content/types";
import { createImageUrl } from "@/utils/image";
import Image from "next/image";
import Link from "next/link";

type MediumVoiceProps = {
  article: Content.Article;
};

const MediumVoice = (props: MediumVoiceProps) => {
  const author = props.article.fields.authors?.[0];
  const title = props.article.fields.teaserTitle || props.article.fields.title;
  const hideBylineImage = props.article.fields.hideBylineImage;

  return (
    <Link
      href={`/${props.article.fields.slug}`}
      className="bg-sand-600 group flex flex-col text-gray-500 relative md:max-h-[381px]"
    >
      <div className="p-8">
        <Icon.Quote className="text-sand-800 fill-sand-800 absolute top-4 -z-1 w-[50px]" />

        {title && (
          <TeaserHeading
            text={title}
            className="text-3xl text-center relative mt-6 md:mt-8 font-semibold"
          />
        )}
      </div>

      <div className="flex items-center justify-between mt-auto ml-8 min-h-[210px]">
        {author?.fields.name && (
          <div className="font-brush text-xl">{author.fields.name}</div>
        )}

        {author?.fields.image?.fields.file?.url && (
          <div className=" w-[160px] h-[160px] absolute right-0 bottom-0">
            <Image
              src={createImageUrl(author.fields.image.fields.file.url, {
                crop: "1:1",
              })}
              alt={author.fields.name || author.fields.image.fields.title!}
              width={160}
              height={160}
              className="object-contain object-right-bottom"
            />
          </div>
        )}
      </div>
    </Link>
  );
};

export default MediumVoice;
